<script setup>
const open = ref(["intro-group"])
const turnOn = ref(true)
const props = defineProps({
    drawer: false,
    permanent: false,
})
const menus = computed(() => {
    return useMenu();
})
</script>
<template>
    <v-navigation-drawer v-model="props.drawer" :permanent="props.permanent" class="" theme="">
        <v-list v-model:opened="open" density="compact" :nav="turnOn" :slim="turnOn" open-strategy="multiple">
            <v-list-group :value="menu.id" v-for="menu in menus">
                <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" rounded="lg" active-class="item-active">
                        <template v-slot:prepend>
                            <v-icon :icon="menu.icon" color="gray" />
                        </template>
                        <v-list-item-title v-text="menu.title" class="memu" />
                    </v-list-item>
                </template>
                <v-list-item v-for="(submenu,i) in menu.submenu" rounded="lg" :key="i" 
                    :value="submenu.id" active-class="item-active"
                    @click="navigateTo(submenu.url); $emit('showMenu', false)">
                    <template v-slot:prepend>
                        <v-icon :icon="submenu.icon" color="gray" />
                    </template>
                    <v-list-item-title  v-text="submenu.title" class="submenu" />
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>

</template>

<style scoped>
.v-list-item-title,
.submenu {
    font-size: 0.925rem !important;
}
.item-active {
    color: #1E88E5;
}
</style>